import Vue from 'vue'
import vuex from 'vuex'
import {validate} from '../common/validate.js'
Vue.use(vuex)

export default new vuex.Store({
  state:{// 缓存用户编辑后的自定义列表数据
    ecsManage: null, // 以页面路由作为唯一识别码
    modalBtnFlag:true, //弹窗按钮可用标志
    tableExtendActive:-1,//table组件扩展状态
    tableEditStatus:false,//TABLE组件在线编辑状态    
    loginBeforePath: null, // 用户门户登录前的需要跳转的路由
    menulist:[],//权限接口
    messageNum: 0, // 未读消息数 ---> index.vue
    local: '',
    showAIBtn: true, // 是否展示客服按钮
    AIiframeRight: '-450px', // 是否显示智能客服iframe窗口
    loginState: false,
  },
  mutations:{
    /*
     接收自定义列表信息，将数据以页面路由作为唯一识别码保存至tableColumns
     */
    catchColumn(state,column){
      if (!validate.isEmpty(state[column.name])) {
        state[column.name] = null
      }
      state[column.name] = column.params
    },
    changeFlag(state,flag){
      state.modalBtnFlag = flag
    },
    changeTableExtendActive(state,index){
      state.tableExtendActive = index
    },
    changeTableEditStatus(state,flag){
      state.tableEditStatus = flag
    },
    changeloginBeforePath (state, url) {
      if (!url) {
        state.loginBeforePath = null
        return
      }
      state.loginBeforePath = {
        path: url.path,
        menuUrl: url.menuUrl
      }
    },
    updateMenu(state,list){
      state.menulist = list
    },
    changeMessageNum (state, argObj) {
      let {init, init_num, change_type} = argObj
      if (init) {
        state.messageNum = init_num
      }
      if (change_type === 'add') {
        if (state.messageNum >= 99) {
          state.messageNum = 99
        } else {
          state.messageNum++
        }
      }
      if (change_type === 'sub') {
        if (state.messageNum <= 0) {
          state.messageNum = 0
        } else {
          state.messageNum--
        }
      }
    },
    // i18n配置
    setLocal (state, lang) {
      localStorage.setItem('local', lang)
      state.local = lang
    },
    changeAIBtnFlag (state, flag) {
      state.showAIBtn = flag
    },
    changeAIiframeRight (state, px) {
      state.AIiframeRight = px
    },
    changeloginState (state, flag) {
      state.loginState = flag
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js